import { render, staticRenderFns } from "./IntelligencePatientFrictionChart.vue?vue&type=template&id=5c118f06&scoped=true"
import script from "./IntelligencePatientFrictionChart.vue?vue&type=script&lang=js"
export * from "./IntelligencePatientFrictionChart.vue?vue&type=script&lang=js"
import style0 from "./IntelligencePatientFrictionChart.vue?vue&type=style&index=0&id=5c118f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c118f06",
  null
  
)

export default component.exports